import { LABELS } from '~/resources/Labels';
import { FormScriptResponse } from '~/models/Comons';
import { SIMPLDialog} from '../.././components/comons/dialog/SimplDialog';

interface DetailProps {
    item: FormScriptResponse;
    onClose: () => void;
}

const valueClass = 'py-3 px-2 bg-[#efefef] rounded-md break-words max-w-[600px]';
const labelClass = 'font-semibold max-w-[300px]';
export const DetailViewScript = ({ item, onClose }: DetailProps) => {
    
    return (
        <SIMPLDialog onCloseModal={onClose} title={LABELS.DetailView}>
            <div className="w-auto pb-5 flex flex-col">
            <div className="flex flex-row mt-3">
                    <div className="flex-1">
                        <div className={labelClass}>{LABELS.DeploymentScriptIDTitle}</div>
                        <div className={valueClass}>{item.scriptIdentify.deploymentScriptId}</div>
                    </div>
                </div>
                <div className="flex flex-row mt-3">
                    <div className="flex-1">
                        <div className={labelClass}>{LABELS.DateAdded}</div>
                        <div className={valueClass}>{item.creationDate}</div>
                    </div>
                    <div className="flex-1 ml-3">
                        <div className={labelClass}>{LABELS.Status}</div>
                        <div
                            className={`${item.active ? 'text-green-600' : 'text-error'} ${valueClass}`}
                        >
                            {item.active ? LABELS.Active : LABELS.Inactive}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row mt-3">
                    <div className="flex-1">
                        <div className={labelClass}>{LABELS.Provider}</div>
                        <div className={valueClass}>{item.cloudProvider.cloudProviderName}</div>
                    </div>
                </div>

                <div className="flex flex-row mt-3">
                    <div className="flex-1">
                        <div className={labelClass}>{LABELS.Title}</div>
                        <div className={valueClass}>{item.title}</div>
                    </div>
                </div>

                <div className="flex flex-row mt-3">
                    <div className="flex-1 truncate">
                        <div className={labelClass}>{LABELS.Description}</div>
                        <div className={valueClass}>{item.description}</div>
                    </div>
                </div>
            </div>
        </SIMPLDialog>
    );
};